import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import YeniRezervasyonModal from './YeniRezervasyonModal';
import DatePicker from './DatePicker';
import { useKapatma } from '../context/KapatmaContext';
import { useKasa } from '../context/KasaContext';
import YeniFaturaModal from './YeniFaturaModal';
import { useAuth } from '../context/AuthContext';
import { GelirEkleModal, GiderEkleModal } from './KasaModals';
import { isDemoMode } from '../config/demoMode';
import DemoBanner from './DemoBanner';

// ── SVG İkon seti ──
const Icons = {
  home:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  hotel:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><path d="M9 3v18M2 9h7M2 15h7M15 7h2M15 11h2M15 15h2"/></svg>,
  wifi:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor"/></svg>,
  wallet:    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/><circle cx="17" cy="15" r="1" fill="currentColor"/></svg>,
  message:   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  chart:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  file:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  barChart:  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  settings:  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>,
  globe:     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>,
  tool:      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>,
};

// ── Menü yapısı ──
const menuItems = [
  { label: 'Ana Sayfa', svgIcon: 'home', path: '/' },
  {
    label: 'Resepsiyon', svgIcon: 'hotel', children: [
      { label: 'Yeni Rezervasyon',       modal: 'rezervasyon',    yetki: 'rezervasyonEkle' },
      { label: 'Rezervasyon Listesi',    path: '/rezervasyon',    yetki: 'rezervasyonGoruntule' },
      { label: 'Misafir Kayıtları',      path: '/misafirler',     yetki: 'misafirGoruntule' },
      { label: 'KBS / Jandarma',         path: '/kbs',            yetki: 'kbsIslemleri' },
      { label: 'Oda Planı',              path: '/room-rack',      yetki: 'rezervasyonGoruntule' },
      { label: 'Doluluk Çizelgesi',      path: '/blokaj',         yetki: 'rezervasyonGoruntule' },
      { label: 'Kat Hizmetleri',         path: '/housekeeping',   yetki: 'housekeeping' },
      { label: 'Walk-in Adisyon',        path: '/walk-in-adisyon', yetki: 'walkInAdisyon' },
      { label: 'Havuz Yönetimi',         path: '/havuz',           yetki: 'havuzYonet', modul: 'havuz' },
      { label: 'Hizmet Randevuları',     path: '/hizmet/randevular', yetki: 'hizmetRandevu', modul: 'hizmetler' },
    ]
  },
  {
    label: 'Online Satış', svgIcon: 'wifi', disabled: true, children: [
      { label: 'Gelen Rezervasyonlar',   path: '/kanal/rezervasyonlar', yetki: 'kanalYonetimi' },
      { label: 'Fiyat & Müsaitlik',      path: '/kanal/fiyat',          yetki: 'kanalYonetimi' },
      { label: 'Satışa Kapat',           modal: 'satisaKapat',          yetki: 'kanalYonetimi' },
      { label: 'Entegrasyon Ayarları',   path: '/kanal/ayarlar',        yetki: 'kanalYonetimi' },
    ]
  },
  {
    label: 'Kasa', svgIcon: 'wallet', children: [
      { label: 'Günlük Kasa',            path: '/kasa/gunluk',          yetki: 'gunlukKasaGoruntule' },
      { label: 'Aylık Kasa',             path: '/kasa/aylik',           yetki: 'genelKasaGoruntule' },
      { label: 'Bakiye Durumu',          path: '/kasa/bakiyeler',       yetki: 'bakiyeGoruntule' },
      { label: 'Taksit & Ödemeler',      path: '/kasa/taksit-odemeler', yetki: 'taksitGoruntule' },
      { label: 'Gelir Ekle',             modal: 'gelirEkle',            yetki: 'kasaGelirEkle' },
      { label: 'Gider Ekle',             modal: 'giderEkle',            yetki: 'kasaGiderEkle' },
    ]
  },
  {
    label: 'SMS', svgIcon: 'message', disabled: true, children: [
      { label: 'SMS Gönder',             path: '/sms/gonder',   yetki: 'smsListesi' },
      { label: 'SMS Ayarları',           path: '/sms/ayarlar',  yetki: 'smsListesi' },
    ]
  },
  {
    label: 'Muhasebe', svgIcon: 'chart', children: [
      { label: 'Gelir Listesi',          path: '/gelir-gider/gelir',  yetki: 'muhasebeListesi' },
      { label: 'Gelir Ekle',             modal: 'gelirEkle',          yetki: 'kasaGelirEkle' },
      { label: 'Gider Listesi',          path: '/gelir-gider/gider',  yetki: 'muhasebeListesi' },
      { label: 'Gider Ekle',             modal: 'giderEkle',          yetki: 'kasaGiderEkle' },
    ]
  },
  {
    label: 'E-Fatura', svgIcon: 'file', disabled: isDemoMode(), modul: 'efatura', children: [
      { label: 'Yeni Fatura Kes',        modal: 'yeniFatura',         yetki: 'efaturaKes' },
      { label: 'Giden Faturalar',        path: '/efatura/giden',      yetki: 'efaturaGoruntule' },
      { label: 'Gelen Faturalar',        path: '/efatura/gelen',      yetki: 'efaturaGoruntule' },
    ]
  },
  {
    label: 'İstatistikler', svgIcon: 'barChart', children: [
      { label: 'Rezervasyon Raporu',     path: '/raporlama/rezervasyon',     yetki: 'raporRezervasyonlar' },
      { label: 'Günlük Fiyat Analizi',   path: '/raporlama/fiyat',           yetki: 'raporFinansal' },
      { label: 'Ortalama Doluluk',       path: '/raporlama/gunluk-ortalama', yetki: 'raporDoluluk' },
      { label: 'Doluluk Tahmini',        path: '/raporlama/forecast',        yetki: 'raporDoluluk' },
      { label: 'Konaklama Vergisi',      path: '/raporlama/konaklama-vergisi', yetki: 'muhasebeListesi' },
      { label: 'KDV Raporu',             path: '/raporlama/kdv',             yetki: 'muhasebeListesi' },
      { label: 'Personel Giderleri',     path: '/raporlama/personel',        yetki: 'raporPersonel' },
      { label: 'Kat Hizmetleri Raporu',  path: '/raporlama/housekeeping',    yetki: 'housekeeping' },
      { label: 'Misafir Ülke Dağılımı',  path: '/raporlama/ulkeler',         yetki: 'misafirGoruntule' },
      { label: 'E-posta Geçmişi',        path: '/raporlama/emailler',        yetki: 'raporSistemLog' },
      { label: 'İşlem Kayıtları',        path: '/raporlama/log',             yetki: 'raporSistemLog' },
    ]
  },
  {
    label: 'Otel Kurulumu', svgIcon: 'settings', children: [
      { label: 'Acente & Firmalar',      path: '/tanimlar/acente',              yetki: 'tanimlarGenel', yakinda: true },
      { label: 'Anlaşmalı Firmalar',      path: '/tanimlar/firmalar',            yetki: 'tanimlarGenel' },
      { label: 'Personel',               path: '/tanimlar/personel',            yetki: 'tanimlarPersonel' },
      { label: 'Personel Tipleri',       path: '/tanimlar/personel-tipleri',    yetki: 'tanimlarPersonel' },
      { label: 'Roller',                 path: '/tanimlar/roller',              yetki: 'tanimlarPersonel' },
      { label: 'Stok & Ürünler',         path: '/tanimlar/stok',                yetki: 'tanimlarGenel' },
      { label: 'Oda Tipleri',            path: '/tanimlar/oda-tipleri',         yetki: 'tanimlarOda' },
      { label: 'Kat / Gruplar',          path: '/tanimlar/oda-gruplari',        yetki: 'tanimlarOda' },
      { label: 'Odalar',                 path: '/tanimlar/odalar',              yetki: 'tanimlarOda' },
      { label: 'Fiyatlandırma',          path: '/tanimlar/oda-fiyatlandirma',   yetki: 'tanimlarOda' },
      { label: 'Doluluk Fiyatlandırma',  path: '/tanimlar/doluluk-fiyat',       yetki: 'tanimlarOda' },
      { label: 'Para Birimleri',         path: '/tanimlar/para-birimleri',      yetki: 'tanimlarFinansal' },
      { label: 'Ödeme Yöntemleri',       path: '/tanimlar/odeme-tipleri',       yetki: 'tanimlarFinansal' },
      { label: 'Banka Hesapları',        path: '/tanimlar/banka-tanimlari',     yetki: 'tanimlarFinansal' },
      { label: 'Gelir Kalemleri',        path: '/tanimlar/gelir-gruplari',      yetki: 'tanimlarFinansal' },
      { label: 'Gider Kalemleri',        path: '/tanimlar/gider-gruplari',      yetki: 'tanimlarFinansal' },
      { label: 'Konaklama Paketleri',    path: '/tanimlar/konaklama-turleri',   yetki: 'tanimlarGenel' },
      { label: 'Ek Hizmetler',           path: '/tanimlar/ek-hizmetler',        yetki: 'tanimlarHizmet', modul: 'hizmetler' },
      { label: 'Oda Bukletleri',         path: '/tanimlar/buklet-tanimlari',    yetki: 'tanimlarGenel' },
      { label: 'Misafir Tipleri',        path: '/tanimlar/misafir-tipleri',     yetki: 'tanimlarGenel' },
      { label: 'Çamaşırhane',            path: '/tanimlar/laundry',             yetki: 'tanimlarGenel', modul: 'laundry' },
    ]
  },
  {
    label: 'Web Sitesi', svgIcon: 'globe', disabled: true, children: [
      { label: 'Genel Ayarlar',          path: '/website/ayarlar',   yetki: 'ayarlar' },
      { label: 'Sayfalar',               path: '/website/sayfalar',  yetki: 'ayarlar' },
      { label: 'SEO',                    path: '/website/seo',       yetki: 'ayarlar' },
      { label: 'Misafir Mesajları',      path: '/website/mesajlar',  yetki: 'ayarlar' },
    ]
  },
  {
    label: 'Ayarlar', svgIcon: 'tool', children: [
      { label: 'Modüller',               path: '/ayarlar/moduller',  yetki: 'ayarlar' },
      { label: 'Vergi Ayarları',         path: '/ayarlar/vergi',     yetki: 'ayarlar' },
      { label: 'Otel Yönetimi',          path: '/ayarlar/oteller',   yoneticiOnly: true },
    ]
  },
];

function sidebarBugunStr() {
  const d = new Date();
  return [String(d.getDate()).padStart(2,'0'), String(d.getMonth()+1).padStart(2,'0'), d.getFullYear()].join('.');
}

function SatisaKapatModal({ onClose }) {
  const bugun = sidebarBugunStr();
  const [basDate, setBasDate] = useState(bugun);
  const [bitDate, setBitDate] = useState(bugun);
  const [odaTip, setOdaTip]   = useState('Standart');
  const { kapatmalar, kapatmaEkle, kapatmaSil } = useKapatma();
  const ODA_TIPLERI = ['Standart', 'Deluxe', 'Suite', 'Superior'];

  return (
    <div className="fixed inset-0 bg-black/40 z-[200] flex items-center justify-center px-4 backdrop-blur-sm" style={{paddingTop:'80px'}}>
      <div className="bg-white w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-base font-bold text-gray-800">🔒 Satışa Kapat</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 w-7 h-7 flex items-center justify-center rounded-lg hover:bg-gray-100">✕</button>
        </div>
        <div className="px-6 py-4 border-b border-gray-100">
          <div className="flex items-end gap-3 flex-wrap">
            <div>
              <label className="text-xs text-gray-500 font-semibold block mb-1.5">Başlangıç</label>
              <DatePicker value={basDate} onChange={val => {
                setBasDate(val);
                const b = val.split('.').reverse().join('-'), e = bitDate.split('.').reverse().join('-');
                if (new Date(b) > new Date(e)) setBitDate(val);
              }} className="w-40" />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-semibold block mb-1.5">Bitiş</label>
              <DatePicker value={bitDate} onChange={setBitDate} minDate={basDate} className="w-40" />
            </div>
            <div>
              <label className="text-xs text-gray-500 font-semibold block mb-1.5">Oda Tipi</label>
              <div className="relative">
                <select value={odaTip} onChange={e => setOdaTip(e.target.value)} className="border border-gray-200 rounded-xl px-3 py-2.5 pr-8 text-sm bg-gray-50 focus:outline-none appearance-none w-32">
                  {ODA_TIPLERI.map(o => <option key={o}>{o}</option>)}
                </select>
                <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
              </div>
            </div>
            <button
              onClick={() => { if (!basDate || !bitDate) return; kapatmaEkle({ id: Date.now(), bas: basDate, bit: bitDate, odaTip }); }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl text-sm font-bold transition-colors"
            >
              Ekle
            </button>
          </div>
        </div>
        <div className="overflow-x-auto max-h-72 overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-gray-50 border-b border-gray-200">
              <tr>
                {['Gönder', 'Başlangıç', 'Bitiş', 'Oda Tipi', 'Sil'].map(h => (
                  <th key={h} className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {kapatmalar.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-10 text-gray-400 text-sm">Henüz kayıt eklenmedi</td></tr>
              ) : kapatmalar.map(k => (
                <tr key={k.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-3 px-4">
                    <button onClick={() => alert(`${k.bas} – ${k.bit} arası "${k.odaTip}" gönderildi.`)} className="bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold px-3 py-1.5 rounded-lg whitespace-nowrap">Gönder »</button>
                  </td>
                  <td className="py-3 px-4 text-gray-700">{k.bas}</td>
                  <td className="py-3 px-4 text-gray-700">{k.bit}</td>
                  <td className="py-3 px-4 text-gray-700">{k.odaTip}</td>
                  <td className="py-3 px-4">
                    <button onClick={() => kapatmaSil(k.id)} className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold px-3 py-1.5 rounded-lg">Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default function Sidebar({ onMobileClose }) {
  const [modalAcik,      setModalAcik]      = useState(false);
  const [satisModalAcik, setSatisModalAcik] = useState(false);
  const [gelirModalAcik, setGelirModalAcik] = useState(false);
  const [giderModalAcik, setGiderModalAcik] = useState(false);
  const [faturaModalAcik,setFaturaModalAcik]= useState(false);
  const [openMenus,      setOpenMenus]      = useState({ 'Resepsiyon': true });
  const navigate  = useNavigate();
  const location  = useLocation();
  const { personel, hasYetkiOrAdmin, refreshOtelAdi, modulAcik } = useAuth();
  const { gelirEkle, giderEkle, gelirGruplari, giderGruplari, personeller, odemeTipleri, bankalar, paraBirimleri, dovizKurlari } = useKasa();
  const isYonetici = personel?.tip === 'Yönetici' || hasYetkiOrAdmin('ayarlar');

  useEffect(() => { if (personel) refreshOtelAdi(); }, [personel?.otelId, refreshOtelAdi]);

  const otelAdi = personel?.otelAdi || 'HotelFlow';
  const initial = otelAdi.charAt(0).toUpperCase();

  const toggleMenu = label => setOpenMenus(p => ({ ...p, [label]: !p[label] }));

  function handleClick(child) {
    if      (child.modal === 'rezervasyon') { setModalAcik(true); onMobileClose?.(); }
    else if (child.modal === 'satisaKapat') { setSatisModalAcik(true); onMobileClose?.(); }
    else if (child.modal === 'gelirEkle')   { setGelirModalAcik(true); onMobileClose?.(); }
    else if (child.modal === 'giderEkle')   { setGiderModalAcik(true); onMobileClose?.(); }
    else if (child.modal === 'yeniFatura' || child.modal === 'faturaKes') { setFaturaModalAcik(true); onMobileClose?.(); }
    else { navigate(child.path); onMobileClose?.(); }
  }

  return (
    <>
      <style>{`
        .sb-scroll { scrollbar-width: thin; scrollbar-color: transparent transparent; }
        .sb-scroll:hover { scrollbar-color: rgba(99,102,241,0.25) transparent; }
        .sb-scroll::-webkit-scrollbar { width: 3px; }
        .sb-scroll::-webkit-scrollbar-track { background: transparent; }
        .sb-scroll::-webkit-scrollbar-thumb { background: transparent; border-radius: 3px; }
        .sb-scroll:hover::-webkit-scrollbar-thumb { background: rgba(99,102,241,0.25); }
      `}</style>

      <div className="w-60 h-full flex flex-col overflow-hidden flex-shrink-0 relative" style={{ background: '#0f172a', transform: 'translateZ(0)', willChange: 'transform' }}>

        {/* Brand / Otel */}
        <div className="px-5 py-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white font-bold text-sm flex-shrink-0 shadow-lg"
              style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)' }}>
              {initial}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-white font-bold text-sm truncate leading-tight">{otelAdi}</p>
              <p className="text-[11px] leading-tight mt-0.5" style={{ color: '#64748b' }}>
                {new Date().toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' })}
              </p>
            </div>
            {/* Mobil kapatma butonu */}
            {onMobileClose && (
              <button onClick={onMobileClose}
                className="flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-slate-500 hover:text-white hover:bg-white/10 transition-all text-sm font-black">
                ✕
              </button>
            )}
          </div>
        </div>

        <DemoBanner />

        {/* Menü */}
        <nav className="sb-scroll flex-1 overflow-y-auto px-3 pb-4">
          {menuItems.filter(item => modulAcik(item.modul))   // kapalı modülün grubu hiç çizilmez
          .map(item => {
            const visibleChildren = item.children?.filter(c =>
              (!c.yetki || hasYetkiOrAdmin(c.yetki)) &&
              (!c.yoneticiOnly || isYonetici) &&
              modulAcik(c.modul)          // otelde kapalı modüller menüde görünmez
            );
            return { ...item, visibleChildren };
          }).filter(item => item.disabled || !item.children || (item.visibleChildren?.length ?? 0) > 0)
          .map(item => {
            const { visibleChildren } = item;
            const isActive = !item.children && location.pathname === item.path;
            const isOpen = openMenus[item.label];
            const hasActiveChild = visibleChildren?.some(c => !c.modal && location.pathname === c.path);
            const isDisabled = item.disabled === true;

            return (
              <div key={item.label} className="mb-0.5">
                <button
                  onClick={() => {
                    if (isDisabled) return;
                    if (item.children) toggleMenu(item.label); else { navigate(item.path); onMobileClose?.(); }
                  }}
                  style={isActive ? { background: '#6366f1', color: '#fff' } : {}}
                  className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-colors duration-200 select-none group
                    ${isDisabled
                      ? 'cursor-not-allowed opacity-60'
                      : 'cursor-pointer'}
                    ${isActive
                      ? 'shadow-lg'
                      : hasActiveChild
                        ? 'text-slate-200'
                        : 'text-slate-400 hover:text-slate-100'}`}
                  onMouseEnter={e => { if (!isActive && !isDisabled) e.currentTarget.style.background = 'rgba(255,255,255,0.07)'; }}
                  onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = ''; }}
                >
                  <div className="flex items-center gap-2.5">
                    <span className={`flex-shrink-0 ${isActive ? 'text-white' : hasActiveChild ? 'text-slate-300' : 'text-slate-500 group-hover:text-slate-300'}`}>
                      {Icons[item.svgIcon]}
                    </span>
                    <span className="text-[13px] font-medium">{item.label}</span>
                  </div>
                  {isDisabled ? (
                    <span className="text-[8px] font-bold tracking-wide px-1.5 py-0.5 rounded-md flex-shrink-0"
                      style={{ background: 'rgba(99,102,241,0.18)', color: '#818cf8' }}>
                      YAKINDA
                    </span>
                  ) : item.children && (
                    <svg
                      className={`flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                      style={{ color: isActive ? '#fff' : '#475569' }}
                      width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  )}
                </button>

                {visibleChildren && isOpen && !isDisabled && (
                  <div className="ml-4 mt-0.5 mb-1 pl-3" style={{ borderLeft: '1px solid rgba(255,255,255,0.07)' }}>
                    {visibleChildren.map(child => {
                      const childActive = !child.modal && location.pathname === child.path;
                      const childYakinda = child.yakinda === true;
                      return (
                        <button
                          key={child.label}
                          onClick={() => { if (!childYakinda) handleClick(child); }}
                          className={`w-full text-left flex items-center gap-2 px-2 py-1.5 rounded-lg text-[12px] transition-colors duration-200
                            ${childYakinda ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
                            ${childActive ? 'font-semibold' : ''}`}
                          style={childActive
                            ? { color: '#a5b4fc', background: 'rgba(99,102,241,0.15)' }
                            : { color: '#64748b' }}
                          onMouseEnter={e => { if (!childActive && !childYakinda) { e.currentTarget.style.color = '#cbd5e1'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; } }}
                          onMouseLeave={e => { if (!childActive) { e.currentTarget.style.color = '#64748b'; e.currentTarget.style.background = ''; } }}
                        >
                          <span className="w-1 h-1 rounded-full flex-shrink-0"
                            style={{ background: childActive ? '#818cf8' : '#334155' }} />
                          <span className="leading-snug">{child.label}</span>
                          {childYakinda && (
                            <span className="ml-auto text-[8px] font-bold tracking-wide px-1.5 py-0.5 rounded-md leading-none flex-shrink-0"
                              style={{ background: 'rgba(99,102,241,0.18)', color: '#818cf8' }}>
                              YAKINDA
                            </span>
                          )}
                          {child.badge && !childYakinda && (
                            <span className="ml-auto text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full leading-none flex-shrink-0"
                              style={{ background: '#10b981' }}>
                              {child.badge}
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer — Personel bilgisi */}
        <div className="px-4 py-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-slate-600 to-slate-700 flex items-center justify-center text-slate-300 text-xs font-bold flex-shrink-0">
              {personel?.adSoyad?.charAt(0) || '?'}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-semibold text-slate-300 truncate leading-tight">{personel?.adSoyad || '—'}</p>
              <p className="text-[10px] leading-tight mt-0.5" style={{ color: '#475569' }}>{personel?.tip || 'Personel'}</p>
            </div>
          </div>
        </div>
      </div>

      {modalAcik && createPortal(
        <YeniRezervasyonModal
          onClose={() => setModalAcik(false)}
          onKaydedildi={() => {
            setModalAcik(false);
            if (location.pathname === '/rezervasyon') navigate(0);
          }}
        />,
        document.body
      )}
      {satisModalAcik  && createPortal(<SatisaKapatModal     onClose={() => setSatisModalAcik(false)} />, document.body)}
      {gelirModalAcik  && (
        <GelirEkleModal
          onClose={() => setGelirModalAcik(false)}
          onKaydet={gelirEkle}
          gelirGruplari={gelirGruplari}
          personeller={personeller}
          odemeTipleri={odemeTipleri}
          bankalar={bankalar}
          paraBirimleri={paraBirimleri}
          dovizKurlari={dovizKurlari}
        />
      )}
      {giderModalAcik  && (
        <GiderEkleModal
          onClose={() => setGiderModalAcik(false)}
          onKaydet={giderEkle}
          giderGruplari={giderGruplari}
          personeller={personeller}
          odemeTipleri={odemeTipleri}
          bankalar={bankalar}
          paraBirimleri={paraBirimleri}
          dovizKurlari={dovizKurlari}
        />
      )}
      {faturaModalAcik && createPortal(<YeniFaturaModal        onKapat={() => setFaturaModalAcik(false)} />, document.body)}
    </>
  );
}
